module.exports = __webpack_public_path__ + "static/media/10.639e6c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/10.png
// module id = 512
// module chunks = 0